// extracted by css-extract-rspack-plugin
export default {"root":"pa_1es","subheading":"mc0loU","questions":"HXESqt"};